import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Button from '@atlaskit/button';
import FolderFilledIcon from '@atlaskit/icon/glyph/folder-filled';
import FolderIcon from '@atlaskit/icon/glyph/folder';
import Tooltip from '@atlaskit/tooltip';

// @source
import * as Styled from '../../styled';
import RemoveButton from './RemoveButton';

const TableGroup = ({
  children,
  isOpen,
  onClick,
  onClickVisible,
  title,
}) => (
  <Styled.Table>
    <Styled.TableRow>
      <Styled.TableRowIcon>
        <Tooltip
          content={isOpen ? 'Hide group' : 'Show group'}
          position="left"
        >
          <Button
            appearance="subtle"
            iconBefore={isOpen ? <FolderIcon size="small" /> : <FolderFilledIcon size="small" />}
            onClick={() => onClickVisible(title)}
            spacing="compact"
          />
        </Tooltip>
      </Styled.TableRowIcon>
      <Styled.TableGroupTitle>{title}</Styled.TableGroupTitle>
      <Styled.TableRowIcon>
        <RemoveButton
          content="Remove group"
          onClick={() => onClick(title, false)}
          props={[]}
        />
      </Styled.TableRowIcon>
    </Styled.TableRow>
    <Styled.TableGroup>
      {children}
    </Styled.TableGroup>
  </Styled.Table>
);

TableGroup.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  onClickVisible: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

TableGroup.defaultProps = {
  children: '',
};

export default TableGroup;
